var overflowWrap = {
  overflowWrap: 'break-word',
  wordWrap: 'break-word',
  wordBreak: 'break-word',
  hyphens: 'auto'
};
export var overflowWrapReset = {
  overflowWrap: 'normal',
  wordWrap: 'normal',
  wordBreak: 'normal',
  hyphens: 'none'
};
export default overflowWrap;